<template>
  <div class="portrait-check-wrapper">
    <w-navbar :icon="'iconchevron-left'"
              nav_title="超级简历证件照"
              @mobileLeftBtn="leftBtnClick"
              v-if="!isRN"
              :isShowLeftIcon="true" />
    <div class="portrait-check-content">

      <div class="image-box">
        <img :src="imgFile" alt="">
      </div>

      <div class="check-box" :class="type">

        <template v-if="type === 'success'">
          <h6><i class="iconfont iconwancheng"></i>检测通过</h6>
          <p>照片已符合制作证件照要求，点击按钮上传电脑</p>
        </template>

        <template v-else-if="type === 'error'">
          <h6><i class="iconfont iconcuowu"></i>照片问题：</h6>
          <p>{{ info.check.join('、') }}</p>
        </template>

      </div>

      <div class="btn-box" :style="isWechatBrowser && 'paddingBottom: 20px;'">
        <div class="btn" @click="debounce(() => { upImgTriggerFunc() }, 300)">重新上传</div>
        <div class="btn" :class="type" @click="debounce(() => { upImgComputerFunc() }, 300)" v-if="isPc">上传电脑</div>
        <div class="btn" :class="type" @click="debounce(() => { makeStart() }, 300)" v-else>开始制作</div>
        <input class="up-img-input" ref="upImgInput" type="file" accept="image/*" @change="upImgChangeFunc()">
      </div>

    </div>
    <!-- loading 动画 -->
    <w-loading :show-text="true" v-show="loadingVsible"/>
  </div>
</template>

<script>
import WNavbar from '@/components/global/w-navbar'
import WLoading from "@/components/global/w-loading"

import { envMixin } from '@/assets/js/mixin/global'
import { componentsMixin } from '@/assets/js/mixin/components'

export default {
  data () {
    return {
      type: 'success', // 可能的值：1. success 通过 2. error 未通过
      imgFile: null, // 照片 base64
      imgType: null, // 照片类型
      photoId: null, // 唯一 id
      info: {}, // 照片质量检测的相关数据信息
      loadingVsible: false, // loading visible
      isRN: false,   // 是否 RN
      isPc: false,      // 是否 PC
      cvToken: '',      // 是否从 editor 跳转
    }
  },
  mixins: [ envMixin, componentsMixin ],
  components: {
    WNavbar,
    WLoading
  },
  created () {
    this.isRN = !!window.ReactNativeWebView
    if(this.isRN){
      this.postMessage('pageMounted', 'pageMounted')
      this.initMessage()
    }
    // 获取相关数据
    const { imgFile, imgType, photoId, info, isPc, cvToken } = this.$route.params
    this.imgFile = imgFile
    this.imgType = imgType
    this.photoId = photoId
    this.info = info
    // 确定类型
    this.type = info && info.status
    this.isPc = !!isPc
    this.cvToken = cvToken
  },
  methods: {
    makeStart() {
      if (this.type !== 'success') {
        this.showToast('照片不符合制作证件照要求，请重新上传')
        return
      }
      let params = {
        imgFile: this.imgFile,
        imgType: this.imgType,
        photoId: this.photoId,
        info: this.info,
        cvToken: this.cvToken,
      }
      this.$db.ls.set('portraitParams', JSON.stringify(params))
      this.$router.push({
        name: 'photo-make-start'
      })
    },
    // initMessage
    initMessage() {
      window.receiveFile = msg => {
        // 拿到 base64 照片
        this.imgFile = msg
        // 照片质量检测
        this.photoCheckFunc(this.imgFile)
      }
    },
    // postMessage
    postMessage(type, data) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type,
        data,
      }))
    },
    // 触发手机上传图片
    upImgTriggerFunc () {
      if (this.isRN) {
        this.postMessage('chooseFile', 'chooseFile')
      } else {
        this.$refs.upImgInput.click()
      }
    },
    // 监听图片
    upImgChangeFunc () {
      let file = this.$refs.upImgInput.files
      // 获取图片类型
      this.imgType = file[0].type.split('/')[1]
      // 处理新上传的图片文件 base64
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = e => {
        // 拿到 base64 照片
        let imgFile = e.currentTarget.result
        // 照片质量检测
        this.photoCheckFunc(imgFile)
      }
    },
    // 上传图片到电脑
    async upImgComputerFunc () {
      if (this.type === 'error') return
      this.loadingVsible = true
      try {
        let params = {
          file_name: `${this.photoId}.${this.imgType}`,
          file_dir: 'cv/portrait/',
          file_data: this.imgFile.split('base64,')[1],
          photo_key: this.photoId
        }
        let res = await this.$api.transferStation.uploadPhoto('cv', params)
        if (res.code === 1000) {
          this.$router.push('/transfer-station/upload-portrait/success')
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVsible = false
      } catch (error) {
        console.log(error)
        this.loadingVsible = false
      }

    },
    // 照片质量检测
    async photoCheckFunc (val) {
      this.loadingVsible = true
      try {
        let params = {
          file: val.split('base64,')[1]
        }
        let res = await this.$api.transferStation.photoCheck(params)
        if (res.code === 1000) {
          this.imgFile = val
          this.type = res.data.status
          this.info = res.data
        } else if (res.code === 201203) {
          this.showToast('请求超时，请重新上传')
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVsible = false
      } catch (error) {
        console.log(error)
        this.loadingVsible = false
      }
    },
    leftBtnClick() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .portrait-check-wrapper {
    width: 100%;

    .portrait-check-content {
      position: relative;
      padding: 44px 0 98px;
      background: #ffffff;

      .image-box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 60vh;
        background: #F4F4F4;

        >img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .check-box {
        margin: 0 20px;
        padding: 14px 16px;
        border-radius: 6px;
        border: 1px solid #ececec;
        margin-top: 16px;

        >h6 {
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 4px;

          >i {
            font-size: 14px;
            margin-right: 4px;
          }
        }

        >p {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }

        &.success {
          color: #2BC11A;
          border-color: #C1EBBB;
          background: rgba(67, 176, 52, 0.05);
        }

        &.error {
          color: #E29436;
          border-color: #FCEBD6;
          background: #FFFAF4;
        }

      }

      .btn-box {
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
        background: #ffffff;
        padding: 10px 20px 42px;
        display: flex;
        align-items: center;
        overflow: hidden;

        .btn {
          flex: 1;
          height: 46px;
          line-height: 46px;
          font-size: 14px;
          font-weight: 500;
          border-radius: 4px;
          text-align: center;

          &:first-of-type {
            color: #FF6644;
            background: rgba(255, 102, 68, 0.1);
            margin-right: 11px;
          }

          &:last-of-type {
            color: #ffffff;
            background: #ff6644;
          }

          &.error {
            opacity: 0.4;
          }

        }

        .up-img-input {
          width: 100%;
          position: absolute;
          z-index: -1;
          left: 0;
          top: -300px;
          opacity: 0;
        }
      }

    }
  }
</style>
